import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { SingleOrderDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { SingleOrderDto } from 'src/app/shared/models/single-order/single-order-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class SingleOrderWorkItem extends WorkItem<SingleOrderDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'SingleOrderWorkItem';
  }
  get database(): string {
    return SingleOrderDB;
  }

  get chunkSize(): number {
    return 250;
  }
}
